import { TenantSelector } from "@optima-stride-ai/optima-app-framework";

export const hayagrivaTenants: TenantSelector[] = [
      {
        id: 'tenant-tenant-one',
        tenantId: 'tenant-tenant-one',
        name: 'TestTenant One',
        shortName: 'TestTenant One',
        description: 'Global Technology and Innovation Leader',
        icon: 'cilBuilding',
        metadata: {
          industry: 'Technology',
          size: 'Enterprise'
        }
      },
      {
        id: 'tenant-tenant-two',
        tenantId: 'tenant-tenant-two',
        name: 'TestTenant Two',
        shortName: 'TestTenant Two',
        description: 'Global Technology and Innovation Leader',
        icon: 'cilBuilding',
        metadata: {
          industry: 'Technology',
          size: 'Enterprise'
        }
      },
      {
        id: 'tenant-tenant-three',
        tenantId: 'tenant-tenant-three',
        name: 'TestTenant Three',
        shortName: 'TestTenant Three',
        description: 'Global Technology and Innovation Leader',
        icon: 'cilBuilding',
        metadata: {
          industry: 'Technology',
          size: 'Enterprise'
        }
      },
      {
        id: 'optima-stride',
        tenantId: 'optima-stride',
        name: 'Optima Stride',
        shortName: 'Optima Stride',
        description: 'Venture Capital and Startup Incubator',
        icon: 'cilRocket',
        metadata: {
          industry: 'Venture Capital',
          size: 'Mid-Market'
        }
      },
     
    ];